import castArray from 'lodash/castArray';
export const serializeQuery = query => {
  return Object.keys(query).map(key => castArray(query[key]).filter(value => value !== undefined && value !== null).map(value => String(value)).filter(value => value !== '').map(value => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&')).filter(Boolean).join('&');
};
export const toQueryString = (url, query) => {
  const queryString = serializeQuery(query);
  return [url, queryString].filter(Boolean).join('?');
};